const messages = {
  title_ja: `<b>全角125文字以内 もしくは 半角英数字250文字以内</b><br>
    タイトルはジャケット画像に記載されたタイトルと一致する必要があります。<br>
    各配信ストアの規程により自動変換（オートキャップ）される場合があります。<br>
    例: MUSIC → Music<br><br>
    使用不可ワード<br>
    例: オリジナルミックス / 配信限定 / デジタルシングル など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。<br><br>
    タイトル欄にバージョン情報は入力しないでください。`,
  title_en: `<b>半角英数字250文字以内</b><br>
    各配信ストアの規程により自動変換（オートキャップ）される場合があります。<br>
    例: MUSIC → Music<br>
    <br>
    アルファベット表記の例<br>
    タイトル:美しい日々<br> アルファベット表記:Utsukushiihibi<br>
    配信ストアによっては、海外ユーザー向けの表記となる場合がございます。<br><br>
    使用不可ワード<br>
    例: Original Mix / Limited / Digital Single など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  title_kana: `<b>全角カナ70文字以内</b><br>半角、全角スペースは使用できません。<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  versions: `<b>バージョン</b><br>
バージョンはオリジナル楽曲と区別するために追加します。<br>入力されたバージョンは自動で楽曲タイトルへ追記されます。<br>
<br>
バージョンの使用例:<br>
2020 Ver.<br>
Remix<br>
Instrumental<br>
Radio Edit<br>
2016 リマスターバージョン<br>
2016 Remastered Version<br>
Acapella Ver.<br>
Cover<br>
Live at 武道館、東京、2018<br>`,
  version_ja: `<b>全角125文字以内 もしくは 半角英数字250文字以内</b><br>
    オリジナルと違ったバージョンの場合に入力してください。<br>
    例: Live from Tokyo, Club Remix, Radio Edit<br><br>
    使用不可ワード<br>
    例: オリジナルミックス / 配信限定 / デジタルシングル など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。<br><br>
    バージョン欄に入力した内容がタイトルの後ろに記載されます。`,
  version_kana: `<b>全角カナ70文字以内</b><br>半角、全角スペースは使用できません。<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  version_en: `<b>半角英数字250文字以内</b><br><br>
    アルファベット表記の例<br>
    タイトル:Live from Tokyo<br> アルファベット表記:Live from Tokyo<br>
    配信ストアによっては、海外ユーザー向けの表記となる場合がございます。<br><br>
    使用不可ワード<br>
    例: Original Mix / Limited / Digital Single など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  genre1: `<b>プルダウンから選択</b><br>
    ・ジャンル1から優先して登録されます。<br>
    ・選択頂いたジャンルが配信ストアに存在しない、または適切なジャンルではないと判断された場合、<br>
    &emsp;事前の通知なしに変更させて頂くことがあります。希望するジャンルが存在しない場合は、できるだけ近いジャンルをお選びください。<br>
    ・「カラオケ」「Spoken Word」「サウンドトラック」の場合は、<br>
    &emsp;Facebook/Instagram ミュージックスタンプに配信することはできません。`,
  genre2: `<b>プルダウンから選択</b><br>
  ・ジャンル1から優先して登録されます。<br>
  ・選択頂いたジャンルが配信ストアに存在しない、または適切なジャンルではないと判断された場合、<br>
  &emsp;事前の通知なしに変更させて頂くことがあります。希望するジャンルが存在しない場合は、できるだけ近いジャンルをお選びください。<br>
  ・「カラオケ」「Spoken Word」「サウンドトラック」の場合は、<br>
  &emsp;Facebook/Instagram ミュージックスタンプに配信することはできません。`,
  label_ja: `<b>全角 もしくは 半角英数字</b><br>
    主に配信ストアのコピーライト・レーベル表記に使用されます。<br>
    空欄の場合、一部の配信ストアでアーティスト名が表示されます。<br>
    正しくない例: 無所属 / インディペンデント / No Label / 第三者の商標 など`,
  label_name_ja: `<b>全角 もしくは 半角英数字</b><br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  label_en: `<b>全角 もしくは 半角英数字</b><br>
    主に配信ストアのコピーライト・レーベル表記に使用されます。<br>
    空欄の場合、一部の配信ストアでアーティスト名が表示されます。<br>
    正しくない例: 無所属 / インディペンデント / No Label / 第三者の商標 など`,
  jan: `<b>半角数字</b><br>
    JANコード、EANコード、UPCコードをお持ちの場合は、入力してください。<br>
    ダッシュ記号 (-) は含みません。<br>
    <a href="/client/faqs/38" target="_blank">JANコードは必要ですか？`,
  jan_tob: `<b>半角数字</b><br>
    JANコード、EANコード、UPCコードをお持ちの場合は、入力してください。<br>
    ダッシュ記号 (-) は含みません。<br>
    <a href="/client/faqs/23" target="_blank">JANコードは必要ですか？`,
  launched: `発売日が決まっているCD等の場合は、発売予定日を 設定してください。
            <br><a href="/client/faqs/37" target="_blank">販売実績・発売日について</a>`,
  launched_tob: `発売日が決まっているCD等の場合は、発売予定日を 設定してください。
            <br><a href="/client/faqs/22" target="_blank">販売実績・発売日について</a>`,
  copyright_c: `(C)マークはジャケットのデザインや歌詞の著作物全般を保護するための表示です。<br>
著作物の最初の発行年、製作者を記載します。`,
  copyright_c_ja: `<b>全角 もしくは 半角英数字</b><br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  copyright_p: `(P)マークは音楽ファイルに関する音楽ファイル製作者の原盤権について保護を 受けるためのものです。<br>
著作物の最初の発行年、製作者を記載します。`,
  copyright_p_ja: `<b>全角 もしくは 半角英数字</b><br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
}
messages.versions_b2b = `${messages.versions}<br><a href="/client/faqs/153" target="_blank">【アルバム・トラックのタイトルにバージョン名を登録したい】</a>`
messages.versions_b2c = `${messages.versions}<br><a href="/client/faqs/152" target="_blank">【アルバム・トラックのタイトルにバージョン名を登録したい】</a>`

export default messages
